module.exports = __webpack_public_path__ + "static/img/4.89e70b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/eng/4.png
// module id = 6vSu
// module chunks = 0